import { render, staticRenderFns } from "./TablaSimulacionSinDetalles.vue?vue&type=template&id=9fe78822&"
import script from "./TablaSimulacionSinDetalles.vue?vue&type=script&lang=js&"
export * from "./TablaSimulacionSinDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports